"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _core = require("@linaria/core");
var _commonStyles = require("../styles/commonStyles");
var _headlineSkeleton = _interopRequireDefault(require("./headline-skeleton"));
var _chevronRight = _interopRequireDefault(require("@ux/icon/chevron-right"));
var _carouselSkeleton = _interopRequireDefault(require("./carousel-skeleton"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
const actionMarqueeSkeletonCss = "aft5am4";
const ActionItem = () => {
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "actionMarqueeItem"
  }, /*#__PURE__*/_react.default.createElement("span", {
    className: (0, _core.cx)(_commonStyles.skeletonTextRow, _commonStyles.skeletonAnimatedBg, 'skeletonActionItemIcon')
  }), /*#__PURE__*/_react.default.createElement("span", {
    className: "skeletonActionItemHeading"
  }, /*#__PURE__*/_react.default.createElement("span", {
    className: (0, _core.cx)(_commonStyles.skeletonTextRow, _commonStyles.skeletonAnimatedBg)
  })), /*#__PURE__*/_react.default.createElement(_chevronRight.default, null));
};
const ActionMarqueeSkeleton = _ref => {
  let {
    hideCarousel = false,
    flip = false
  } = _ref;
  return /*#__PURE__*/_react.default.createElement("div", {
    className: actionMarqueeSkeletonCss
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _core.cx)('bodyContainer', flip ? 'flip' : ''),
    style: {
      '--randomized-color': (0, _commonStyles.nbaItemColorRandomizer)()
    }
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: 'actionMarqueCard'
  }, /*#__PURE__*/_react.default.createElement(_headlineSkeleton.default, {
    className: "actionMarqueeHeadline"
  })), /*#__PURE__*/_react.default.createElement("div", {
    className: 'actionMarqueActions'
  }, /*#__PURE__*/_react.default.createElement("span", {
    className: (0, _core.cx)(_commonStyles.skeletonTextRow, _commonStyles.skeletonAnimatedBg, 'skeletonActionHeading')
  }), /*#__PURE__*/_react.default.createElement("span", {
    className: (0, _core.cx)(_commonStyles.skeletonTextRow, _commonStyles.skeletonAnimatedBg, 'skeletonActionHeading')
  }), /*#__PURE__*/_react.default.createElement("div", {
    className: "actionMarqueItems"
  }, /*#__PURE__*/_react.default.createElement(ActionItem, null), /*#__PURE__*/_react.default.createElement(ActionItem, null), /*#__PURE__*/_react.default.createElement(ActionItem, null)))), !hideCarousel && /*#__PURE__*/_react.default.createElement(_carouselSkeleton.default, {
    className: "carouselSkeleton"
  }));
};
ActionMarqueeSkeleton.propTypes = {
  hideCarousel: _propTypes.default.bool,
  flip: _propTypes.default.bool
};
var _default = ActionMarqueeSkeleton;
exports.default = _default;